const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000/api';

const JOBS = {
    CREATE_JOB: `${API_BASE_URL}/jobs/create/`,
    UPDATE_JOB: `${API_BASE_URL}/jobs/update/`,
    USER_JOBS: `${API_BASE_URL}/jobs/user-jobs/`,
    PUBLIC_PROFILE_JOBS: `${API_BASE_URL}/jobs/public-profile-jobs/`,
    VIEW_JOB: (id) => `${API_BASE_URL}/jobs/${id}/`,
    DELETE_JOB: `${API_BASE_URL}/jobs/delete/`,
    VIEW_ALL_JOBS: `${API_BASE_URL}/jobs/all/`,
    SEARCH: `${API_BASE_URL}/jobs/search/`,
    TOGGLE_STATUS: (id) => `${API_BASE_URL}/jobs/toggle-status/${id}/`,
    TOGGLE_LIKE: (id) => `${API_BASE_URL}/jobs/toggle-like/${id}/`, 
  };
  
  export default JOBS;